import { useUiStore } from '@/store/uiStore'
import { cn } from '@/utils/cn'

const typeStyles = {
  success: 'bg-[#111827] text-white border-[var(--accent3)]',
  error: 'bg-[#111827] text-white border-[var(--error)]',
  warning: 'bg-[#111827] text-white border-[var(--accent2)]',
  info: 'bg-[#111827] text-white border-[var(--accent)]',
}

export function ToastContainer() {
  const { toasts, dismissToast } = useUiStore()

  if (toasts.length === 0) return null

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[1000] flex flex-col gap-2 items-center pointer-events-none">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          onClick={() => dismissToast(toast.id)}
          className={cn(
            'animate-toast-in pointer-events-auto',
            'px-5 py-3 rounded-[var(--radius-sm)] border-l-2',
            'font-mono text-[13px] shadow-lg cursor-pointer',
            'min-w-[260px] max-w-[400px] text-center',
            typeStyles[toast.type]
          )}
        >
          {toast.message}
        </div>
      ))}
    </div>
  )
}
